export default __webpack_public_path__ + "static/media/fifa.caee2743.svg";